module.exports = __webpack_public_path__ + "static/media/flag-popup-header.bafa6641.png";